import { Accordion } from "@mui/material";

export const MuiAccordion = Accordion;
